export default __webpack_public_path__ + "static/media/wordpress.ba022347.png";